<template>
  <div ref="input" class="input" :class="{ full: input.full_width }">
    <label class="optionalPosition">
      {{ input.label }}
      <p class="optional" v-if="input.optional">(optional)</p>
    </label>

    <div class="md-layout-item md-size-50">
      <md-field>
        <div class="money-holder">
          <span class="money-sign">$</span>
          <money
            pattern="[0-9]*"
            @input="saveInput"
            class="money"
            v-model="answer"
            type="text"
            v-bind="money"
          ></money>
        </div>
      </md-field>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import money from "v-money";

// register directive v-money and component <money>
Vue.use(money, { precision: 0 });

export default {
  name: "MoneyInput",
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      answer: null,
      money: {
        decimal: ".",
        thousands: ",",
        precision: 0,
        masked: false,
      },
    };
  },
  mounted() {},
  created() {
    this.answer = this.input.value;
  },
  firestore() {
    return {};
  },
  methods: {
    saveInput() {
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    },
    /*
    formatMoney(e) {
      this.$nextTick(() => {
        const isNumber = /^[0-9]$/i.test(e.key);
        if (isNumber) {
          let num = this.answer.split(",").join("");
          if (num.length > 8) num = num.slice(0, -1);
          this.answer = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.$emit(
            "updateAnswer",
            this.questionIndex,
            this.answerKey,
            this.answer
          );
        } else {
          if (e.key != "Backspace") {
            this.answer = this.answer.slice(0, -1);
          }
        }
      });
    },
    */
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.money-holder {
  position: relative;
  .money-sign {
    position: absolute;
    bottom: 41%;
    left: 14px;
    font-size: 20px;
    opacity: 0.5;
  }
  .money {
    padding-left: 30px !important;
  }
}
</style>
